module.exports = __webpack_public_path__ + "static/media/legf_1.403b6680.gif";